import { Flex, Box } from '@chakra-ui/core'
import React from 'react'
import { MarkUpText } from './MarkUpText'
import { PopMedia } from './PopMedia'
import { PopCreatorText } from './PopCreatorText'
import { useSelector } from 'react-redux'
import { isRtlSelector } from 'redux/selectors/general'
interface IProps {
  pop_title: string
  pop_body: string
  pop_image_url: string
  pop_initiator: number
  created_by: string
  audio?: string
  video?: string
  bodyContent?: React.ReactNode
  horizontalPadding?: string
  showCreator?: boolean
  layout?: 'default' | 'link'
}
export default function PopBody({
  created_by,
  pop_title,
  pop_body,
  pop_image_url,
  pop_initiator,
  audio,
  video,
  bodyContent,
  horizontalPadding = '55px',
  showCreator = true,
  layout = 'default',
}: IProps) {
  const isRtl = useSelector(isRtlSelector)
  const isLinkLayout = layout === 'link'
  return (
    <Flex minH="100px" flexDir="column" alignItems="center" px={horizontalPadding} textAlign="center">
      {showCreator && <PopCreatorText created_by={created_by} />}

      <Box
        style={{
          wordBreak: 'break-word',
          whiteSpace: 'inherit',
          paddingTop: isLinkLayout ? '0' : '10px',
          color: isLinkLayout ? '#111827' : undefined,
          width: showCreator ? undefined : '100%',
          textAlign: 'center',
          display: showCreator ? undefined : 'flex',
          flexDirection: showCreator ? undefined : 'column',
        }}
      >
        <MarkUpText
          text={pop_title}
          initiator={pop_initiator}
          fontFamily={isLinkLayout ? 'inherit' : 'Arial'}
          lineHeight={isLinkLayout ? '32px' : '25px'}
          fontSize={isLinkLayout ? '26px' : '24px'}
          fontWeight={isLinkLayout ? '700' : '600'}
        />
      </Box>
      {bodyContent !== undefined ? (
        <Box width="100%" pt={isLinkLayout ? '24px' : '10px'}>
          {bodyContent}
        </Box>
      ) : (
        <>
          <Box
            style={{
              width: '100%',
              wordBreak: 'break-word',
              whiteSpace: 'inherit',
              paddingTop: '10px',
              textAlign: isRtl ? 'right' : 'left',
            }}
          >
            <MarkUpText
              text={pop_body}
              initiator={pop_initiator}
              fontFamily="Arial"
              lineHeight="25px"
              fontSize="20px"
            />
          </Box>
          <PopMedia pop_image_url={pop_image_url} audio={audio} video={video} />
        </>
      )}
    </Flex>
  )
}
